/**
 * Benefit lead-in shown at the top of the « i » tooltip next to
 * « Paiement en un clic » — sells the option without mentioning storage.
 */
export const DIRECT_PAYMENT_BENEFIT_TEXT =
    "Vos règlements sans renseigner votre moyen de paiement à chaque fois.";

/**
 * Consent text shown by the « i » control next to « Paiement en un clic ».
 *
 * Choosing the direct checkout authorizes FlowRide to store a payment method
 * reference for future purchases — the text must stay honest about that: no
 * banking data is ever stored by FlowRide, only an opaque provider token.
 *
 * Version-aligned with `SAVED_PAYMENT_METHOD_CONSENT_VERSION` (backend
 * `purchase.constants.ts`): any wording change bumps both.
 */
export const DIRECT_PAYMENT_CONSENT_TEXT =
    "En choisissant le paiement en un clic, vous autorisez l'enregistrement de votre moyen de paiement pour vos prochains achats. " +
    "Pour votre sécurité, FlowRide ne stocke aucune donnée bancaire : nous conservons uniquement un identifiant sécurisé. " +
    "Vos coordonnées sont chiffrées et stockées exclusivement par notre prestataire de paiement certifié.";
